module.exports = __webpack_public_path__ + "static/media/logo.cd1c835c.png";